module.exports = __webpack_public_path__ + "img/deepsource-only-logo-white.fec4ec0.svg";